import { useState } from "react";
import { bookmarkMethods } from "@/mocks/homeData";

export default function BookmarkSection() {
  const [active, setActive] = useState(bookmarkMethods[0].key);
  const method = bookmarkMethods.find((m) => m.key === active) ?? bookmarkMethods[0];

  return (
    <section id="bookmark" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <p className="font-label text-sm text-primary-600 font-medium">防走失收藏</p>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
            四种收藏方式，挑一种就够了
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            收藏本页是这套方案里唯一需要养成的习惯。下面按使用设备列出具体步骤，选一个最适合你的方式照着做即可。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-7">
            <div className="flex flex-wrap gap-1.5">
              {bookmarkMethods.map((m) => (
                <button
                  key={m.key}
                  type="button"
                  onClick={() => setActive(m.key)}
                  className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap border ${
                    active === m.key
                      ? "bg-primary-500 text-background-50 border-primary-500"
                      : "bg-background-100 text-foreground-700 border-background-200 hover:border-primary-300 hover:text-primary-700"
                  }`}
                >
                  <i className={m.icon} />
                  {m.label}
                </button>
              ))}
            </div>

            <div className="mt-5 rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950 text-2xl">
                  <i className={method.icon} />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-950">
                    {method.title}
                  </h3>
                  <p className="text-sm text-foreground-600">{method.desc}</p>
                </div>
              </div>

              <ol className="mt-5 space-y-3">
                {method.points.map((point, index) => (
                  <li key={point} className="flex items-start gap-3">
                    <span className="mt-0.5 w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                      {index + 1}
                    </span>
                    <span className="text-sm md:text-base text-foreground-800 leading-relaxed">{point}</span>
                  </li>
                ))}
              </ol>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="w-full aspect-square rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20flat%20illustration%20of%20a%20cozy%20desk%20with%20a%20laptop%2C%20a%20phone%20and%20sticky%20notes%20showing%20a%20heart%20bookmark%20symbol%2C%20warm%20cream%20and%20coral%20palette%2C%20soft%20amber%20light%2C%20minimal%20editorial%20style%2C%20subtle%20paper%20grain&width=1000&height=1000&seq=taohua-bookmark-2026&orientation=squarish"
                alt="桌面上摆放电脑、手机与便签，示意多种收藏方式"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-4 rounded-lg border border-background-200 bg-secondary-50 p-4">
              <div className="flex items-center gap-2 text-secondary-900 font-medium text-sm">
                <i className="ri-information-line text-lg" />
                建议同时保留两种方式
              </div>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">
                比如「浏览器书签 + 手机主屏」，一个用于电脑，一个用于手机，互相备份，几乎不可能同时失效。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}